import React, { useEffect } from 'react'
import { Route, Switch } from "react-router-dom";
import ScrollTop from './ScrollTop';
import GeneralContent from 'components/GeneralContent';
import HeaderRouter from './HeaderRouter';
import FooterRouter from './FooterRouter';
import SuspenseRouter from './SuspenseRouter';
import {routes, Error404, Error404Help} from './routes';
import RenderService from 'services/Render'
import Loader from 'components/Loader'

const Routes = () => {
    const withHeaderHelp = (typeof window !== 'undefined') && (window.location.pathname.indexOf('/centro-ayuda') !== -1)

    const serverRender = RenderService.isRenderData();

    useEffect(() => {
        if(document){
            const serverLoeader = document.querySelector('.server-loader');
            if(serverLoeader) {
                setTimeout(() => {
                    serverLoeader.remove();
                }, 20);
            }
        }
    },[]);

    return (
        <ScrollTop>
            <HeaderRouter/>
            <GeneralContent/>
            <div className='server-loader'><Loader /></div>
            <SuspenseRouter serverRender={serverRender}>
                <Switch>
                    {routes.map((route, i)=>
                        <Route
                            exact
                            key={i}
                            path={route.path}
                            component={route.component}
                        />)}
                    {!withHeaderHelp && <Route render={props => (<Error404 {...props} />)} />}
                    {withHeaderHelp && <Route render={props => (<Error404Help {...props} />)} />}
                </Switch>
            </SuspenseRouter>
            <FooterRouter/>
        </ScrollTop>
    )
}

export default Routes;
